import { checkoutShippingAddressesStyles } from "@insite/content-library/Widgets/CheckoutShipping/CheckoutShippingAddresses";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import { css } from "styled-components";

Object.assign(checkoutShippingAddressesStyles, {
    shippingAddressGridItem: {
        width: [12, 12, 12, 6, 6],
        css: css`
            padding: 0 25px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`
                            padding: 15px;
                        `,
                        css`
                            padding: 15px;
                        `,
                    ],
                    "max",
                )}
        `,
    },
    billingAddressGridItem: {
        width: [12, 12, 12, 6, 6],
        css: css`
            padding: 0 25px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`
                            padding: 15px;
                        `,
                        css`
                            padding: 15px;
                        `,
                    ],
                    "max",
                )}
        `,
    },
});
